module.exports = "/images/laser-tag.svg?37257d52bacbd49e3f51ee530de3425e";